import useEntity from "../../hooks/useRole";
import RoleDetail from "../../components/role/RoleDetail/RoleDetail";
import RoleScoped from "../../components/role/RoleDetail/RoleScoped";
import RoleTabs from "../../components/role/RoleDetail/RoleTabs";
import { useGetRoleQuery } from "../../apis/Role.api";
import { PrimaryRole } from "../../types/models/Role";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoleDetailPage = () => {

    useTitle(t`Details Role`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { roleId: id } = useParams();

    const { data, refetch } = useGetRoleQuery(PrimaryRole.fromPath(id))
    const { deleteRole } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteRole(data, '..')
    }, [data, deleteRole])

    if (id === 'scoped') {
        return (<RoleScoped/>)
    }

    return (
        <Box data-testid="Role-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <RoleDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/Roles/update/view') &&
                        <Button size="small" variant="outlined" data-testid="Role-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { 
        session.hasPermission('', 'applications/auth/entities/Roles/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="Role-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <RoleTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default RoleDetailPage;
